import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TableFilters } from '../../_model/table-response/table-filters';
import { ExportService} from '../../service/export.service'
import {Router} from '@angular/router';
import { User } from '../../_model/user/user';
import { UserService } from '../../service/user.service';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


@Component({
  selector: 'app-single-input-filter',
  templateUrl: './single-input-filter.component.html',
  standalone: true,
  imports: [MatInputModule, MatFormFieldModule, MatSelectModule, ReactiveFormsModule, MatProgressSpinnerModule],
  styleUrls: ['./single-input-filter.component.scss']
})
export class SingleInputFilterComponent implements OnInit {

  @Input() tableFilters!: TableFilters[];
  @Output() selectedFilter = new EventEmitter<FormGroup>();

  localTableFilters!: TableFilters[];
  filterForm!: FormGroup;

  filterApplied = false;
  excelClicked = false;
  isLoadingResults = false;

  constructor(private router: Router, private userService: UserService,
     private exportService : ExportService,
     private fb: FormBuilder) {
    this.initializeFilter();
  }

  ngOnInit() {
    this.localTableFilters = this.tableFilters;
  }

  applyFilter() {
    if(this.excelClicked){
      this.getDatatoExcel(this.filterForm);
    } else{
      this.selectedFilter.emit(this.filterForm);
      this.filterApplied = true;
    }
  }

  isExcelClicked() {
    this.excelClicked = true;
  }

  isSearchClicked(){
    this.excelClicked = false;
  }

  reset() {
    this.initializeFilter();
    this.selectedFilter.emit(this.filterForm);
    this.filterApplied = false;
  }

  private initializeFilter() {
    this.filterForm = this.fb.group({
      tableFilter: '',
      value: ''
    });
  }

  isArray = () => this.filterForm.value.tableFilter.values && this.filterForm.value.tableFilter.values.length;

  isFilterSet = () => !(this.filterForm.value.tableFilter && this.filterForm.value.value);

  private getDatatoExcel(formValues : FormGroup) {
    this.isLoadingResults = true;
    let user: User = this.userService.getUser();
    this.exportService.getDataToExcel(formValues,user.brand).subscribe(response => {
    this.isLoadingResults = false;
    window.open(response.data, "_blank");
    }, () => this.isLoadingResults = false)
  }

  hasRoute(currroute: string) {
    return this.router.url === currroute;
  }
}
